import {
  Avatar,
  Box,
  chakra,
  Flex,
  Icon,
  SimpleGrid,
  useColorModeValue,
} from "@chakra-ui/react";
import { FaGithub, FaLinkedin, FaTwitter } from "react-icons/fa";
import { MdMail } from "react-icons/md";

const testimonials = [
  {
    name: "Tushar Sharma",
    role: "Frontend Web Developer",
    contact: "Contact for work together",
    content:
      "This quiz web app is built using React JS. It allows users to select quiz criteria from a list of options and answer questions. The app tracks their performance and displays it on the scoreboard. It is also designed to be responsive and user-friendly.",
    avatar: "https://avatars.githubusercontent.com/u/123295629?v=4",
    githubLink: "https://github.com/TusharSharma131",
    LinkedInLink: "https://www.linkedin.com/in/tushar-sharma-53425521b",
    TwitterLink: "https://twitter.com/ImTusharrSharma",
    MailLink: "https://mail.google.com/mail/u/1/#inbox?compose=new",
  },
];

const TestimonialCard = ({
  name,
  role,
  content,
  contact,
  avatar,
  githubLink,
  LinkedInLink,
  TwitterLink,
  MailLink,
}) => {
  const boxShadowColor = useColorModeValue("white", "black");

  return (
    <Flex
      boxShadow={"lg"}
      maxW={"640px"}
      direction={{ base: "column-reverse", md: "row" }}
      width={"full"}
      rounded={"xl"}
      p={10}
      justifyContent={"space-between"}
      position={"relative"}
      bg={useColorModeValue("gray.800", "white")}
      _after={{
        //content: '""',
        position: "absolute",
        height: "21px",
        width: "29px",
        left: "35px",
        top: "-10px",
        backgroundSize: "cover",
        backgroundImage: `url("data:image/svg+xml, %3Csvg xmlns='http://www.w3.org/2000/svg' width='29' height='21' viewBox='0 0 29 21' fill='none'%3E%3Cpath d='M6.91391 21C4.56659 21 2.81678 20.2152 1.66446 18.6455C0.55482 17.0758 0 15.2515 0 13.1727C0 11.2636 0.405445 9.43939 1.21634 7.7C2.0699 5.91818 3.15821 4.3697 4.48124 3.05454C5.84695 1.69697 7.31935 0.678787 8.89845 0L13.3157 3.24545C11.5659 3.96667 9.98676 4.94242 8.57837 6.17273C7.21266 7.36061 6.25239 8.63333 5.69757 9.99091L6.01766 10.1818C6.27373 10.0121 6.55114 9.88485 6.84989 9.8C7.19132 9.71515 7.63944 9.67273 8.19426 9.67273C9.34658 9.67273 10.4776 10.097 11.5872 10.9455C12.7395 11.7939 13.3157 13.1091 13.3157 14.8909C13.3157 16.8848 12.6542 18.4121 11.3311 19.4727C10.0508 20.4909 8.57837 21 6.91391 21ZM22.5982 21C20.2509 21 18.5011 20.2152 17.3488 18.6455C16.2391 17.0758 15.6843 15.2515 15.6843 13.1727C15.6843 11.2636 16.0898 9.43939 16.9007 7.7C17.7542 5.91818 18.8425 4.3697 20.1656 3.05454C21.5313 1.69697 23.0037 0.678787 24.5828 0L29 3.24545C27.2502 3.96667 25.6711 4.94242 24.2627 6.17273C22.897 7.36061 21.9367 8.63333 21.3819 9.99091L21.702 10.1818C21.9581 10.0121 22.2355 9.88485 22.5342 9.8C22.8756 9.71515 23.3238 9.67273 23.8786 9.67273C25.0309 9.67273 26.1619 10.097 27.2715 10.9455C28.4238 11.7939 29 13.1091 29 14.8909C29 16.8848 28.3385 18.4121 27.0155 19.4727C25.7351 20.4909 24.2627 21 22.5982 21Z' fill='%239F7AEA'/%3E%3C/svg%3E")`,
      }}
      _before={{
        content: '""',
        position: "absolute",
        zIndex: "-1",
        height: "full",
        maxW: "640px",
        width: "full",
        filter: "blur(40px)",
        transform: "scale(0.98)",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        top: 0,
        left: 0,
      }}
    >
      <Flex
        direction={"column"}
        textAlign={"justify"}
        justifyContent={"space-between"}
      >
        <chakra.p
          color={useColorModeValue("whiteAlpha.700", "gray.700")}
          fontFamily={"Sans-Serif"}
          fontWeight={"bold"}
          fontSize={"14px"}
          pb={2}
        >
          {content}
        </chakra.p>
        <chakra.p
          fontFamily={"Sans-Serif"}
          color={useColorModeValue("whiteAlpha.700", "gray.700")}
          fontWeight={"bold"}
          fontSize={16}
          pb={2}
        >
          {name}
          <chakra.span
            fontFamily={"Poppins"}
            fontWeight={"bold"}
            color={"red.500"}
          >
            {" "}
            - {role}
          </chakra.span>
        </chakra.p>
        <chakra.p
          color={useColorModeValue("whiteAlpha.700", "gray.700")}
          fontFamily={"Sans-serif"}
          fontWeight={"bold"}
          fontSize={16}
        >
          {contact}
        </chakra.p>
        <Flex align="Center" justifyContent={"end"} mt={1}>
          <chakra.a
            href={githubLink}
            target="_blank"
            rel="noopener noreferrer"
            color={useColorModeValue("white", "black")}
            boxShadow={{ boxShadowColor }}
            mr={7}
            mt={2}
            _hover={{ color: useColorModeValue("purple.500", "purple.500") }}
          >
            <Icon as={FaGithub} boxSize={6} />
          </chakra.a>

          <chakra.a
            href={LinkedInLink}
            target="_blank"
            rel="noopener noreferrer"
            color={useColorModeValue("blue.500", "blue.600")}
            mr={7}
            mt={2}
            _hover={{ color: useColorModeValue("red.500", "red.500") }}
          >
            <Icon as={FaLinkedin} boxSize={6} />
          </chakra.a>

          <chakra.a
            href={TwitterLink}
            target="_blank"
            rel="noopener noreferrer"
            color={useColorModeValue("#1DA1F2", "#1D9BF0")}
            mr={7}
            mt={2}
            _hover={{ color: useColorModeValue("orange.500", "orange.500") }}
          >
            <Icon as={FaTwitter} boxSize={6} />
          </chakra.a>

          <chakra.a
            href={MailLink}
            target="_blank"
            rel="noopener noreferrer"
            color={useColorModeValue("red.500", "red.500")}
            mr={7}
            mt={2}
            _hover={{ color: useColorModeValue("#0489c9", "#0489c9") }}
          >
            <Icon as={MdMail} boxSize={7} />
          </chakra.a>
        </Flex>
      </Flex>
      <Avatar
        src={avatar}
        height={"95px"}
        width={"95px"}
        alignSelf={"auto"}
        m={{ base: "0 0 35px 0", md: "0 0 0 50px" }}
      />
    </Flex>
  );
};

export default function About() {
  return (
    <Flex
      textAlign={"center"}
      pt={10}
      justifyContent={"center"}
      direction={"column"}
      width={"full"}
    >
      <Box width={{ base: "full", sm: "lg", lg: "xl" }} margin={"auto"}>
        <chakra.h3
          fontFamily={"Nunito"}
          fontWeight={"bold"}
          fontSize={22}
          textTransform={"uppercase"}
          color={"#20bf6b"}
        >
          Quiz Web App
        </chakra.h3>
        <chakra.h1
          py={5}
          fontSize={32}
          fontFamily={"Nunito"}
          fontWeight={"bold"}
          color={useColorModeValue("#20bf6b", "#20bf6b")}
        >
          Ready to Play? Dive into Quizzes!
        </chakra.h1>
        <chakra.h2
          margin={"auto"}
          width={"90%"}
          fontFamily={"Inter"}
          fontWeight={"medium"}
          color={useColorModeValue("gray.500", "gray.400")}
        >
         "Unleash your knowledge on my Exciting Website!"
        </chakra.h2>
      </Box>
      <SimpleGrid
        columns={{ base: 1, xl: 1 }}
        spacing={"20"}
        mt={16}
        mx={"auto"}
      >
        {testimonials.map((cardInfo, index) => (
          <TestimonialCard {...cardInfo} key={index} index={index} />
        ))}
      </SimpleGrid>
      <Box>
        <Icon viewBox="0 0 40 35" mt={14} boxSize={10} color={"#ff0033"}>
          <path
            fill={"currentColor"}
            d="M10.7964 5.04553e-07C8.66112 -0.000123335 6.57374 0.632971 4.79827 1.81922C3.0228 3.00547 1.63898 4.69158 0.82182 6.66433C0.00466116 8.63708 -0.209132 10.8079 0.207477 12.9021C0.624087 14.9964 1.65239 16.9201 3.16233 18.4299L19.1153 34.3828C19.2395 34.5074 19.3871 34.6062 19.5496 34.6736C19.7121 34.741 19.8863 34.7757 20.0622 34.7757C20.2381 34.7757 20.4123 34.741 20.5748 34.6736C20.7373 34.6062 20.8848 34.5074 21.0091 34.3828L36.962 18.4272C38.9319 16.3917 40.0228 13.6636 39.9996 10.8311C39.9764 7.99858 38.8409 5.28867 36.838 3.28573C34.835 1.28279 32.1251 0.147283 29.2926 0.124081C26.4601 0.100879 23.732 1.19184 21.6965 3.1617L20.0622 4.79337L18.4305 3.1617C17.4276 2.15892 16.237 1.36356 14.9267 0.821064C13.6163 0.278568 12.2119 -0.000433066 10.7937 5.04553e-07H10.7964Z"
          />
        </Icon>
      </Box>
    </Flex>
  );
}
